/**
 * Cart Validator
 *
 * This script validates cart items to ensure that the "Monthly" delivery frequency option
 * is not used for the "Corporate Fruits Subscription" product when it's disabled.
 */

document.addEventListener("DOMContentLoaded", function () {
  // Flag to control whether the Monthly option is enabled
  const enableMonthly = false;

  // Function to validate cart items
  function validateCartItems() {
    // Check if we're on a cart page or have cart items
    const cartItems = document.querySelectorAll(".cart-item");
    if (!cartItems.length) return;

    // Loop through cart items
    cartItems.forEach((item) => {
      // Check if this is the Corporate Fruits Subscription product
      const productTitle = item.querySelector(".cart-item__name");
      if (
        productTitle &&
        productTitle.textContent.includes("Corporate Fruits Subscription")
      ) {
        // Find the delivery frequency property
        const properties = item.querySelectorAll(".product-option");
        properties.forEach((prop) => {
          const propText = prop.textContent;
          if (
            propText.includes("Delivery Frequency") &&
            propText.includes("Monthly")
          ) {
            if (!enableMonthly) {
              // If Monthly is selected but disabled, reload the page to trigger server-side validation
              // This will force a refresh of the cart with the invalid option removed
              window.location.reload();
            }
          }
        });
      }
    });
  }

  // Run validation when the page loads
  validateCartItems();

  // Also run validation when the cart is updated
  document.addEventListener("cart:updated", validateCartItems);
});
